import { v4 as uuidv4 } from 'uuid';

export class TargetItem {
  uuid: string = uuidv4();

  name?: string;

  itemUnit?: string;

  count?: number = 0;

  constructor(init?: Partial<TargetItem>) {
    Object.assign(this, init);

    if (!this.uuid) {
      this.uuid = uuidv4();
    }
  }
}

const targetItems: Array<TargetItem> = [
  new TargetItem({
    name: 'ユニークドリンク',
    itemUnit: '本',
  }),
  new TargetItem({
    name: 'ユニークドリンク（12本入り）',
    itemUnit: 'ケース',
  }),
];

export default targetItems;
